import script from "./marketPoster.vue?vue&type=script&setup=true&lang=js"
export * from "./marketPoster.vue?vue&type=script&setup=true&lang=js"

import "./marketPoster.vue?vue&type=style&index=0&id=8a5d85cc&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a5d85cc"]])

export default __exports__